import React from "react";
import { Group as MGroup, Text, Button, Tooltip, Menu, Badge } from "@mantine/core";
import { FiChevronDown, FiCheck } from "react-icons/fi";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  selectDrofusOccurrenceValidationListTypeRows,
  selectDrofusOccurrenceValidationResponsibilityRows,
  selectActiveSpecifiedItem,
  selectActiveRoomColoringId,
} from "../DrofusOccurrenceValidationBarSelectors";
import { setActiveRoomColoringIdThunk } from "../../designThunk";

const makePlaceholder = (w = 14) => <span style={{ width: w, display: "inline-block" }} />;

export const DrofusOccurrenceValidationSpecifiedArticlesSection: React.FC = () => {
  const dispatch = useAppDispatch();

  const listTypeRows = useAppSelector(selectDrofusOccurrenceValidationListTypeRows);
  const responsibilityRows = useAppSelector(selectDrofusOccurrenceValidationResponsibilityRows);
  const activeSpecifiedItem = useAppSelector(selectActiveSpecifiedItem);
  const activeRoomColoringId = useAppSelector(selectActiveRoomColoringId);
  const hasRows = listTypeRows.length > 0 || responsibilityRows.length > 0;

  return (
    <MGroup gap="sm" align="center" wrap="nowrap">
      <Menu withinPortal position="bottom-start" shadow="md" width={320} disabled={!hasRows}>
        <Menu.Target>
          <Tooltip
            label={
              !hasRows ? "Ingen forekomstvalidering tilgjengelig. Valider rommene for å få resultater."
                : "Sammenlign programmerte forekomster fra dRofus med modellen. Velg samlet resultat, liste eller ansvar. Valget erstatter standardromfargene."
            }
            position="bottom"
            withArrow
            openDelay={250}
          >
            <span tabIndex={!hasRows ? 0 : undefined}><Button
              size="xs"
              radius="sm"
              variant={activeSpecifiedItem ? "filled" : "light"}
              color="blue"
              rightSection={<FiChevronDown size={14} />}
              style={{ paddingLeft: 14, paddingRight: 12, fontWeight: 600 }}
              aria-label="Velg forekomstvalidering"
              disabled={!hasRows}
            >
              {activeSpecifiedItem
                ? activeSpecifiedItem.kind === "overall" ? "Samlet resultat"
                  : `${activeSpecifiedItem.kind === "listType" ? "Liste" : "Ansvar"}: ${activeSpecifiedItem.value}`
                : "Velg forekomstfilter"}
            </Button></span>
          </Tooltip>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Item
            onClick={() => dispatch(setActiveRoomColoringIdThunk(undefined))}
            leftSection={!activeSpecifiedItem ? <FiCheck size={14} /> : makePlaceholder()}
          >
            <Text size="sm">Ingen forekomstfilter</Text>
          </Menu.Item>

          <Menu.Divider />

          <Menu.Label>Liste fra dRofus</Menu.Label>
          {listTypeRows.map((item) => {
            const isSelected = item.id === activeRoomColoringId;
            return (
              <Menu.Item
                key={item.id}
                onClick={() => dispatch(setActiveRoomColoringIdThunk(item.id))}
                leftSection={isSelected ? <FiCheck size={14} /> : makePlaceholder()}
                rightSection={isSelected ? <Badge size="xs">Aktiv</Badge> : null}
              >
                <Text size="sm" truncate>
                  {item.kind === "overall" ? "Samlet" : item.value}
                </Text>
              </Menu.Item>
            );
          })}

          {responsibilityRows.length > 0 && (
            <>
              <Menu.Divider />
              <Menu.Label>Ansvar</Menu.Label>
              {responsibilityRows.map((item) => {
                const isSelected = item.id === activeRoomColoringId;
                return (
                  <Menu.Item
                    key={item.id}
                    onClick={() => dispatch(setActiveRoomColoringIdThunk(item.id))}
                    leftSection={isSelected ? <FiCheck size={14} /> : makePlaceholder()}
                    rightSection={isSelected ? <Badge size="xs">Aktiv</Badge> : null}
                  >
                    <Text size="sm" truncate>
                      {item.value}
                    </Text>
                  </Menu.Item>
                );
              })}
            </>
          )}
        </Menu.Dropdown>
      </Menu>
    </MGroup>
  );
};
